<template>
  <v-row>
      <v-col cols="12">
          <vuetify-table
            :headers="headers"
            :api-u-r-l="apiURL"
            :title="title"
            :back="true"
            back-u-r-l="cuentas"
          >
          </vuetify-table>
      </v-col>
  </v-row>
</template>

<script>
import VuetifyTable from '~/components/VuetifyTable';

export default {
    middleware: 'auth',
    metaInfo() {
        return { title: 'Historial de Movimientos' };
    },
    components: {
        VuetifyTable,
    },
    props: {
      historyId: { default: '' },
    },
    data: () => ({
      headers: [
        {
          text: 'Transacción UUID',
          value: 'transaction_uuid',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Tipo de Movimiento',
          value: 'type_movement',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Descripción',
          value: 'description',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Folios',
          value: 'folios',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Fecha',
          value: 'date_movement',
          align: 'left',
          sortable: true,
        },
      ],
    }),
    computed: {
        apiURL() {
          return `/api/history/${this.historyId}`;
        },
        title() {
          return 'Historial de Cuenta';
        },
    },
};
</script>

<style scoped>
  .v-data-table::v-deep th {
    font-size: 6px !important;
  }
  .v-data-table::v-deep td {
    font-size: 8px !important;
  }
</style>
